export const filterByDatapoint = (field, value, shouldExcludeValue) => (args, d) => {
    const values = Array.isArray(value) ? [...value] : [value];
    const dpa = d.datapoints?.filter((di) => di.name === field)?.[0]?.value?.toString() || "";
    if (shouldExcludeValue === "true") {
        return values.every((x) => dpa !== x?.toString() || "");
    }
    return values.some((x) => dpa === x?.toString() || "");
};
